import executeApi from 'shared/executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemError } from "../constants";

/** セッションチェック */
const sessionCheck = async (
  screenId: string,
  action: string,
  yearEdition: string
) => {
  // 認証
  const session = await fetchAuthSession();
  const email = session.tokens?.idToken?.payload?.email;
  const sessionId = session.tokens?.idToken?.payload?.sessionId;
  const jwtToken = session.tokens?.idToken?.toString();
  // SmeFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_SME_FRONT_API_ROOT!;
  // セッション確認API PATH
  const path = "/auth/session/execution";
  const request = {
    "mailAddress": email,
    "sessionId": sessionId,
    "screenAndActionId": screenId + "_" + action,
    "yearEdition":yearEdition
  };

  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, request);
    // レスポンスコード返却
    if (!response || response.data.res_cd == "") {
      return SystemError
    } else {
      return response.data.res_cd
    }
  } catch (e) {
    return SystemError;
  }
};

export default sessionCheck;
